import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Stores from '../config/stores';
import { useContext } from 'react';


import StoreSelector from './StoreSelector';
import { StoreContext } from '../contexts/StoreContext';


const StoreSelectorCollection = (props) => {

    const { stores } = useContext(StoreContext);
    const storeKeys = Object.keys(stores);
    const enabledStoreKeySet = Array.isArray(props.enabledStoreKeys)
        ? new Set(props.enabledStoreKeys)
        : null;
    const highlightedStoreKeySet = new Set(
        Array.isArray(props.highlightedStoreKeys) ? props.highlightedStoreKeys : []
    );
    const mobileColumnCount = 4;
    const mobileFillerCount = (mobileColumnCount - (storeKeys.length % mobileColumnCount)) % mobileColumnCount;
    const toReadableStoreName = (storeKey) => {
        const configuredName = (Stores[storeKey]?.name || '').trim();
        const fallbackName = storeKey
            .replace(/([a-zA-Z])([A-Z])/g, '$1 $2')
            .replace(/([A-Za-zÆØÅæøå])(\d)/g, '$1 $2')
            .replace(/(\d)([A-Za-zÆØÅæøå])/g, '$1 $2')
            .trim();

        const baseName = configuredName || fallbackName;

        return baseName
            .replace(/Super\s*Brugsen/gi, 'Super Brugsen')
            .replace(/Dagli'\s*Brugsen/gi, 'Dagli Brugsen')
            .replace(/REMA\s*1000/gi, 'Rema 1000')
            .replace(/Coop\s*365/gi, 'Coop 365')
            .replace(/\s+/g, ' ')
            .trim();
    };

    if(props.direction === "horizontal") {
        return (
            <div className="store-selector-grid" aria-label="Vælg supermarkeder">
                {storeKeys.map((store) => (
                    <StoreSelector
                        key={store}
                        logo={Stores[store].logo}
                        storeName={store}
                        displayName={toReadableStoreName(store)}
                        wrapperClassName="store-selector-grid-item"
                        disabled={Boolean(enabledStoreKeySet && !enabledStoreKeySet.has(store))}
                        isLocationMatch={highlightedStoreKeySet.has(store)}
                    />
                ))}
                {Array.from({ length: mobileFillerCount }).map((_, index) => (
                    <div
                        key={`mobile-store-filler-${index}`}
                        className="store-selector-grid-item store-selector-grid-filler"
                        aria-hidden="true"
                    />
                ))}
            </div>
        );
    } else {
        return (
            <>
                <Row>
                    <Col>
                        <div>Netto</div>
                    </Col>
                </Row>            <Row>
                    <Col>
                        <div>SuperBrugsen</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div>SuperBrugsen</div>
                    </Col>
                </Row>
            </>
        );
    }

}

export default StoreSelectorCollection;
